import { Component, OnInit, effect, inject, signal } from '@angular/core';
import { RouterOutlet, RouterLink } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { ThemeService } from './core/theme.service';
import { AuthService } from './core/auth.service';
import { CryptoService } from './core/crypto.service';
import { MessageService } from './core/message.service';
import { LegalModalComponent } from './shared/legal-modal';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink, LegalModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly theme = inject(ThemeService);
  protected readonly auth = inject(AuthService);
  protected readonly cryptoService = inject(CryptoService);
  protected readonly messages = inject(MessageService);
  protected readonly year = new Date().getFullYear();
  protected readonly showLegal = signal(false);
  private readonly swUpdate = inject(SwUpdate);

  /** Refresh the navbar unread badge whenever a session (re)appears. */
  private readonly unreadOnLogin = effect(() => {
    if (this.auth.isAuthenticated()) {
      void this.messages.loadUnread().catch(() => {});
    }
  });

  ngOnInit(): void {
    this.theme.init();

    // Keep the new-message notification fresh while signed in.
    setInterval(() => {
      if (this.auth.isAuthenticated()) {
        void this.messages.loadUnread().catch(() => {});
      }
    }, 30_000);

    // PWA: when a new build has been downloaded, activate it on next load.
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(filter((e): e is VersionReadyEvent => e.type === 'VERSION_READY'))
        .subscribe(() => {
          if (confirm('A new version of PassKing is available. Reload now?')) {
            document.location.reload();
          }
        });
    }
  }

  logout(): void {
    this.auth.logout();
  }
}
